module.exports = __webpack_public_path__ + "static/media/Vinil.127c6823.png";